import * as type from "../../types/API/logPayments";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getLogPaymentsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_LOG_PAYMENTS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LOG_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_LOG_PAYMENTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getLogPaymentByIdReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_LOG_PAYMENT_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LOG_PAYMENT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.GET_LOG_PAYMENT_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addLogPaymentsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_LOG_PAYMENTS:
      return {
        ...state,
        loading: true,
      };
    case type.ADD_LOG_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.ADD_LOG_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateLogPaymentsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_LOG_PAYMENTS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_LOG_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_LOG_PAYMENTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteLogPaymentsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_LOG_PAYMENTS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_LOG_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_LOG_PAYMENTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
